import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[auto-focus]',
  standalone: true,
})
export class AutoFocusDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    // preventScroll avoids the browser scrolling ancestor containers to bring
    // the focused element into view, which can momentarily shift surrounding
    // layout (e.g. the map list) when the element is inside a side drawer.
    this.elementRef.nativeElement.focus({ preventScroll: true });
  }
}
